import React from 'react';
import PropTypes from 'prop-types';

import Fade from 'react-reveal/Fade';
import styled from 'styled-components';
import Box from 'common/src/components/Box';

import Container from 'common/src/components/UI/Container';

const FeatureContainer = styled.div`
   {
    padding: 15px;
    @media (min-width: 992px) {
      padding: 30px;
    }
    background: #f0f0f0;
    margin: 0 10px 10px 10px;
    box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.25);
    transition: 0.35s ease-in-out;

    .line-red {
      height: 5px;
      background: rgba(235, 210, 179, 0.78);
    }

    .title {
      margin-left: 30px;

      .text {
        margin-top: 10px;
        font-weight: 500;
        font-size: 22px;
        @media (min-width: 992px) {
          font-size: 32px;
        }
        color: #000000;
      }
    }

    .list {
      padding: 30px 30px;
      .sub-title {
        font-weight: 600;
        margin-bottom: 10px;
      }
    }
  }
`;
const ChatSection = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  background: #fafafa;
  padding: 40px 0;

  .content {
    background: #ffffff;
    text-align: center;
    margin: 20px;
    padding: 20px;

    width: 500px;

    .title {
      font-weight: 500;
      font-size: 25px;
      @media (min-width: 992px) {
        font-size: 38px;
      }
      color: #000000;
      margin-bottom: 15px;
    }

    .desc {
      margin-bottom: 15px;
      font-size: 12px;
      @media (min-width: 992px) {
        font-size: 15px;
      }
    }

    button {
      cursor: pointer;
      padding: 10px 50px;
      color: #ffffff;
      background: #000000;
    }
  }
`;
const AddressContainer = styled.div`
  padding-left: 20px;
  padding-top: 20px;
  margin-bottom: 15px;

  @media (min-width: 992px) {
    padding-left: 100px;
  }

  .office-add {
    .title {
      width: 150px;
      font-weight: 500;
      font-size: 25px;

      @media (min-width: 992px) {
        width: 150px;
        font-size: 42px;
      }
      margin-bottom: 15px;
    }
  }
`;
const FAQSection = styled.section`
  padding: 15px 30px;
  background: #d5e6ea;

  @media (min-width: 992px) {
    padding: 40px 100px;
  }

  .faq-sec {
    display: block;
    margin-bottom: 15px;

    .title {
      font-weight: 500;
      font-size: 27px;

      @media (min-width: 992px) {
        font-size: 42px;
      }
      color: #000000;
      margin-bottom: 20px;
    }

    .content {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      .text {
        width: auto;
        @media (min-width: 992px) {
          width: 550px;
        }
        margin-bottom: 15px;
      }

      button {
        cursor: pointer;
        padding: 10px 50px;
        color: #ffffff;
        background: #000000;
      }
    }
  }
`;
const NewBox = styled.div`
  padding: 15px;

  @media (min-width: 992px) {
    padding: 40px;
  }

  background: #f5f5fa;

  .office-box {
    display: flex;
    flex-wrap: wrap;

    .email-box {
      display: flex;
      flex-wrap: wrap;
    }
  }

  .col {
    flex-grow: 1;
  }
`;

const ContactBlock = ({}) => {
  return (
    <>
      <Container>
        <Fade bottom casacde>
          <ChatSection>
            <div className="content">
              <div className="title">Chat with us now</div>
              <div className="desc">
                Get support right away with one of our customer service agents
                (Mon-Fri 9am-5pm)
              </div>
              <button onClick={() => window.Intercom('show')}>
                Chat with us
              </button>
            </div>
            <div className="content">
              <div className="title">Send us a message</div>
              <div className="desc">
                Send us a message and a member of our team will get back to you
                shortly
              </div>
              <a href={'mailto:hello@flipserve.com'}>
                <button>Send Message</button>
              </a>
            </div>
          </ChatSection>
        </Fade>
        <Fade bottom cascade>
          <NewBox>
            <div className="office-box">
              <div className="col">
                <AddressContainer>
                  <div className="office-add">
                    <div className="title">Our Office</div>

                    <div className="add">
                      101 <br></br>
                      Jefferson Drive <br></br>
                      1st Floor<br></br>
                      Menlo Park<br></br>
                      CA 94025
                    </div>
                  </div>
                </AddressContainer>
              </div>
              <div className="email-box col">
                <div className="col">
                  <FeatureContainer>
                    <div className="title">
                      <div className="text">Support</div>
                    </div>
                    <div className="list">
                      <div className="sub-title">Email Address</div>
                      support@flipserve.com
                    </div>
                  </FeatureContainer>
                  <div
                    style={{
                      margin: '0 10px 10px 10px',
                      height: '5px',
                      background: 'rgba(175, 234, 188, 0.78)'
                    }}
                  ></div>
                  <FeatureContainer>
                    <div className="title">
                      <div className="text">Sales</div>
                    </div>
                    <div className="list">
                      <div className="sub-title">Email Address</div>
                      sales@flipserve.com
                    </div>
                  </FeatureContainer>
                </div>

                <div className="col">
                  <FeatureContainer>
                    <div className="title">
                      <div className="text">General Enquiries</div>
                    </div>
                    <div className="list">
                      <div className="sub-title">Email Address</div>
                      hello@flipserve.com
                    </div>
                  </FeatureContainer>
                  <div
                    style={{
                      margin: '0 10px 10px 10px',
                      height: '5px',
                      background: 'rgba(235, 210, 179, 0.78)'
                    }}
                  ></div>
                  <FeatureContainer>
                    <div className="title">
                      <div className="text">Press & Media</div>
                    </div>
                    <div className="list">
                      <div className="sub-title">Email Address</div>
                      hello@flipserve.com
                    </div>
                  </FeatureContainer>
                </div>
              </div>
            </div>
          </NewBox>
        </Fade>

        <Fade bottom cascade>
          <FAQSection>
            {' '}
            <div className="faq-sec">
              <div className="title">See our FAQs</div>

              <div className="content">
                <div>
                  <div className="text">
                    The common questions we receive from our customers are all
                    covered in our FAQ section. Please take a look to get an
                    answer to your question right away.
                  </div>
                </div>

                <div>
                  <button
                    onClick={() => {
                      window.location.href = '/pricing/#faq';
                    }}
                  >
                    Go to FAQs
                  </button>
                </div>
              </div>
            </div>{' '}
          </FAQSection>
        </Fade>
      </Container>
    </>
  );
};

ContactBlock.propTypes = {
  sectionWrapper: PropTypes.object,
  secTitleWrapper: PropTypes.object,
  row: PropTypes.object,
  col: PropTypes.object,
  secHeading: PropTypes.object,
  secText: PropTypes.object,
  featureItemHeading: PropTypes.object,
  featureItemDes: PropTypes.object,
  featureTitle: PropTypes.object,
  iconStyle: PropTypes.object,
  featureItemBox: PropTypes.object,
  gobutton: PropTypes.object,
  metricscol: PropTypes.object,
  metricsrow: PropTypes.object,
  metricsItemBox: PropTypes.object,
  metricsTitle: PropTypes.object
};

ContactBlock.defaultProps = {
  iconStyle: {
    fontSize: '10px'
  },
  featureItemBox: {
    textAlign: 'center',
    pl: '50px',
    pr: '50px'
  },
  metricsTitle: {
    fontSize: '42px',
    fontWeight: '600'
  },

  metricsItemBox: {
    border: '0px',
    pl: '50px',
    pr: '50px'
  },
  featureTitle: {
    fontSize: '18px',
    fontWeight: '400',
    color: '#343d48',

    mb: '20px',
    letterSpacing: '-0.020em'
  },
  sectionWrapper: {
    as: 'section',
    pt: ['60px', '80px', '80px', '80px'],
    pb: ['60px', '80px', '80px', '80px'],
    id: 'feature_section'
  },
  secTitleWrapper: {
    mb: ['20px', '30px']
  },
  secText: {
    textAlign: 'center',
    fontSize: ['12px', '12px', '14px', '16px'],

    fontWeight: '400',
    color: '#5d646d',
    letterSpacing: '-0.025em',
    mb: '0',
    ml: 'auto',
    mr: 'auto',

    lineHeight: '1.6',
    width: '45%',
    maxWidth: '100%'
  },
  secHeading: {
    textAlign: 'center',
    fontSize: ['20px', '24px', '26px', '30px'],
    fontWeight: '500',
    color: '#0f2137',
    letterSpacing: '-0.025em',
    mb: '15px',
    ml: 'auto',
    mr: 'auto',
    lineHeight: '1.12',
    width: '60%',
    maxWidth: '100%'
  },
  row: {
    flexBox: true,
    flexWrap: 'wrap',
    ml: '-15px',
    mr: '-15px'
  },
  col: {
    className: 'col',
    width: [1, 1 / 2, 1 / 2, 1 / 2],
    pr: '15px',
    pl: '15px',
    mb: '30px'
  },
  metricsrow: {
    flexBox: true,
    flexWrap: 'wrap',
    mt: '75px',
    mb: '60px'
  },
  metricscol: {
    textAlign: 'center',
    width: [1, 1 / 2, 1 / 4, 1 / 4],
    className: 'metrics_col',
    bg: '#fff'
  },
  featureItemHeading: {
    fontSize: ['18px', '18px', '24px', '28px'],
    fontWeight: '500',
    color: '#0f2137',

    mb: ['10px', '12px', '20px', '24px'],
    letterSpacing: '-0.020em'
  },
  featureItemDes: {
    fontSize: ['14px', '14px', '14px', '15px'],
    lineHeight: '1.75',
    color: '#343d48',
    mb: ['20px', '20px', '20px', '20px']
  },
  gobutton: {
    type: 'button',
    fontSize: '14px',
    fontWeight: '600',
    borderRadius: '4px',
    pl: '22px',
    pr: '22px',
    colors: 'secondaryWithBg',
    minWidth: '150px'
  }
};

export default ContactBlock;
